<h1 mat-dialog-title>{{ 'common.words.details' | translate }}
  <span *ngIf="data?.element?.name">- {{ data?.element?.name }}</span>
</h1>
<mat-dialog-content>
  <div class="input-wrapper w-100 d-flex mb-2">
    <div class="custom-label">{{ 'dialogs.fileDetails.name' | translate }}:</div>
    <div class="w-100 text-right">
      {{ data?.element?.name }}
    </div>
  </div>
  <div class="input-wrapper w-100 d-flex mb-2">
    <div class="custom-label">{{ 'dialogs.fileDetails.originalName' | translate }}:</div>
    <div class="w-100 text-right">
      {{ data?.element?.originalName }}
    </div>
  </div>
  <div class="input-wrapper w-100 d-flex mb-2">
    <div class="custom-label">{{ 'dialogs.fileDetails.size' | translate }}:</div>
    <div class="w-100 text-right">
      {{ (data?.element?.size / 1024)?.toFixed(2) }} KB
    </div>
  </div>
  <div class="w-100 mb-2">
    <div class="custom-label">{{ 'dialogs.fileDetails.description' | translate }}:</div>
    <textarea class="w-100" readonly>{{ data?.element?.description }}</textarea>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">{{ 'common.cta.ok' | translate }}</button>
</mat-dialog-actions>